<template>
  <custom-dialog class="factory-stock-entire-item-dialog" width="450px" :title="model.title" :visible="visible" v-on="$listeners" :append-to-body="true">
    <div class="dialog-body">
      <el-form :model="form" :rules="rules" size="small" ref="form" label-position="top">
        <el-row>
          <el-col :span="24">
            <el-form-item label="Modem Sn" prop="ModemSN">
              <el-input v-model="form.modemSn" :disabled="true" style="100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('dms_entire_Item_dialog.chan_pinSN')" prop="productSn">
              <custom-select
                url="productValidList"
                filterable
                v-model="form.productSn"
                :params="{ isAll: true }"
                :props="{ label: 'snCodeCountry', value: 'productSn' }"
                @change="onProductSnChange"
                width="100%"
              ></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('dms_entire_Item_dialog.chan_pin_xing_hao')" prop="productCode">
              <el-input v-model="form.productCode" placeholder="" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('dms_entire_Item_dialog.ISTzhan_dian')" prop="websiteName">
              <custom-select
                v-model="form.websiteName"
                filterable
                url="websiteSelectList"
                :params="{ websiteEnv: this.websiteEnv, websiteType: 1 }"
                @change="onWebsiteChange"
                :props="{ label: 'websiteName', value: 'websiteName' }"
                width="100%"
              ></custom-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],

  data() {
    return {
      ossConfig: {},
      item: {},
      // visible: false,
      fileList: [],
      form: {
        modemBatteryId: '',
        productCode: '',
        productSn: '',
        modemSn: '',
        websiteName: '',
        testType: ''
      },
    };
  },
  mounted() {
    this.initDialog();
  },

  computed: {
    rules() {
      return {
        modemSn: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
        productSn: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
        productCode: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
        websiteName: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
      };
    },
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        // this.visible = true;
      });
      if (this.model.type === 'edit') {
        this.$setFormatData(this.form, this.model.data);
        // this.form.partCode = this.model.data.partCode;
      }
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    onProductSnChange(item) {
      this.form.productCode = item ? item.productCode : '';
      this.form.websiteCode = item ? item.websiteCode : '';
      this.form.websiteName = item ? item.websiteName : '';
    },
    onWebsiteChange(item) {
      this.form.websiteCode = item ? item.websiteCode : '';
    },
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'edit') {
          this.saveUpdate();
        }
      });
    },

    // 保存编辑
    saveUpdate: function () {
      this.$postJSON(apis.modemBatteryUpdate, this.form).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.closeDialog();
        this.$emit('success', this.form);
      });
    },
  },
};
</script>

<style lang="scss">
.entire-item-dialog {
  .title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    line-height: 24px;
    font-size: 16px;
    margin-bottom: 24px;
  }
  .left {
    border-right: 1px solid #eef2f8;
    padding-right: 24px;
  }
  .right {
    padding-left: 24px;
  }
  .el-form-item--small.el-form-item {
    margin-bottom: 14px;
  }
}
</style>
